export default __webpack_public_path__ + "static/media/crossIcon2.10c7c8d7.svg";